// extracted by mini-css-extract-plugin
export var alert = "styles-module--alert--464e6";
export var icon = "styles-module--icon--616cf";
export var text = "styles-module--text--05e61";
export var textSvg = "styles-module--textSvg--03eec";